import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import SingleValidation from "components/DesignComponents/PasswordValidation/SingleValidation";

import { DIGITS, LOWERCASE, SPECIAL_SYMBOLS, UPPERCASE } from "./constants";
import {
    PASSWORD_RULES,
    PasswordRules,
    PasswordValidationProps
} from "./types";

const PasswordValidation = ({
    password,
    repeatPassword,
    onRulesMet
}: PasswordValidationProps) => {
    const { t } = useTranslation();

    const [isRuleMet, setIsRuleMet] = useState<PasswordRules>({
        [PASSWORD_RULES.CharactersLength]: false,
        [PASSWORD_RULES.AllowedCharacters]: false,
        [PASSWORD_RULES.PasswordsMustMatch]: false
    });

    useEffect(() => {
        const isPassword = password.length > 0;
        const isCharactersLength =
            password.length >= 8 && password.length <= 32;
        const arePasswordsMatch = isPassword && password === repeatPassword;

        const checkAllowedCharacters = () => {
            const ALLOWED_CHARACTERS = `${LOWERCASE}${UPPERCASE}${DIGITS}${SPECIAL_SYMBOLS}`;

            return (
                isPassword &&
                [...password].every(char => ALLOWED_CHARACTERS.includes(char))
            );
        };

        const areAllowedCharacters = checkAllowedCharacters();

        setIsRuleMet({
            [PASSWORD_RULES.CharactersLength]: isCharactersLength,
            [PASSWORD_RULES.AllowedCharacters]: areAllowedCharacters,
            [PASSWORD_RULES.PasswordsMustMatch]: arePasswordsMatch
        });

        onRulesMet(
            isCharactersLength && areAllowedCharacters && arePasswordsMatch
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [password, repeatPassword]);

    const rules = Object.keys(isRuleMet) as PASSWORD_RULES[];

    return (
        <div
            css={css({
                "& > div": {
                    display: "flex",
                    alignItems: "center"
                },

                "& > div + div": {
                    marginTop: "4px"
                }
            })}
        >
            {rules.map(rule => {
                const name =
                    rule === PASSWORD_RULES.AllowedCharacters
                        ? t(
                              `Dialog##set bluetooth password##rules##allowed characters`,
                              { specialSymbols: [...SPECIAL_SYMBOLS].join(" ") }
                          )
                        : t(`Dialog##set bluetooth password##rules##${rule}`);

                return (
                    <SingleValidation
                        key={rule}
                        isActive={isRuleMet[rule]}
                        ruleName={name}
                    />
                );
            })}
        </div>
    );
};

export default PasswordValidation;
